$(function () {

	 $('.tagline').each(function(){
        var words = $(this).text().split(" ");
        var total = words.length;
        $(this).empty();
        for (index = 0; index < total; index ++){
            $(this).append($("<span /> ").text(words[index] + ' '));
        }
    });

	$('.lang_select').mouseleave(function(){
		var $input = $('#lang_drop').is(":checked");
		if($input){
			$('.lang_select .dropdown-toggle').click();
		}
	})

	 $('#country').flagStrap({
        countries: {
            "EU": "Europe",
            "US": "English"
        },
        buttonSize: "",
        buttonType: "btn-block text-left",
        labelMargin: "10px",
        scrollable: false,
        scrollableHeight: "350px"
    });


	$('.quantity .fa').click(function(){
		
		var $qty = $('#qty').val();

		if($(this).hasClass('fa-plus')){
			$('#qty').val(Number($qty) + 1);
		}else{
			if($('#qty').val() > 1){
				$('#qty').val(Number($qty) - 1);	
			}else{
				$('#qty').val(0);
			}
		}
	});

	$('#filter_by, .btn-aside-close').click(function(){
		$('#filter').toggleClass('active');
	})


	// range slider
	// $( "#slider-range" ).slider({
	// 		range: true,
	// 		min: 0,
	// 		max: 500,
	// 		values: [ 75, 300 ],
	// 		slide: function( event, ui ) {
	// 			$( "#amount" ).val( "$" + ui.values[ 0 ] + " - $" + ui.values[ 1 ] );
	// 		}
	// 	});
	// 	$( "#amount" ).val( "$" + $( "#slider-range" ).slider( "values", 0 ) +
	// 		" - $" + $( "#slider-range" ).slider( "values", 1 ) );
		
});